export default IconTestPipe2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-test-pipe-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M15 3v15a3 3 0 0 1 -6 0v-15" />
  <path d="M9 12h6" />
  <path d="M8 3h8" />
</svg>`;